import { createLogger } from "@/domain/logging";

export const log = createLogger("ANIMATION");
